import React from 'react';
import { Users, MessageSquare } from 'lucide-react';

type Props = {
  totalThreads?: number;
  totalReplies?: number;
  loading?: boolean;
};

const ForumHeroBar: React.FC<Props> = ({ totalThreads, totalReplies, loading }) => (
  <div className="forum-hero-bar glow-card">
    <div>
      <span className="forum-hero-bar__eyebrow">Topluluk Forumu</span>
      <h1 className="forum-hero-bar__title">Konular</h1>
      <p className="forum-hero-bar__desc">Soru sor, not iste ve tartışmalara katıl.</p>
    </div>
    <div className="forum-hero-bar__stats">
      <div className="forum-stat-pill">
        <MessageSquare size={16} />
        <span>{loading ? '…' : totalThreads ?? '—'}</span>
        <small>konu</small>
      </div>
      <div className="forum-stat-pill">
        <Users size={16} />
        <span>{loading ? '…' : totalReplies ?? '—'}</span>
        <small>yanıt</small>
      </div>
    </div>
  </div>
);

export default ForumHeroBar;
